import { ActionType, LegalType } from '../../types';

export const LegalActions = {
    loadOpenSourceStarted: () =>
        ({
            type: 'Legal/LoadOpenSource/Started',
        } as const),

    loadOpenSourceSucceeded: () =>
        ({
            type: 'Legal/LoadOpenSource/Succeeded',
            payload: {
                list: [
                    { id: LegalType.ReactJs, name: 'React' },
                    { id: LegalType.EatonWirelessControllerEula, name: 'LICENCE.EULA_WIRELESS_CONTROLLER' },
                    { id: LegalType.EatonWirelessControllerOss, name: 'LICENCE.OSS_WIRELESS_CONTROLLER' },
                    { id: LegalType.OpenSourceBuildingSafetyManager, name: 'LEGAL.OPEN_SOURCE_BSM' },
                    {
                        id: LegalType.OpenSourceBuildingSafetyManagerCloud,
                        name: 'LEGAL.OPEN_SOURCE_BSM_CLOUD',
                    },
                ] as Array<{
                    id: LegalType;
                    name: string;
                }>,
                data: '',
                type: LegalType.OpenSource,
            },
        } as const),

    loadOpenSourceFailed: () =>
        ({
            type: 'Legal/LoadOpenSource/Failed',
        } as const),
};

export type LegalAction = ActionType<typeof LegalActions>;
